/**
 * Cross-product animal picker for quantity-breaks multi-qty tiers.
 */
(function () {
  var initialized = new WeakSet();
  var mediaBuyboxMixSeeded = new WeakSet();
  var DUAL_VARIANT_PRODUCT_ID = "10106806534474";
  var DUAL_VARIANT_HEAVY_ID = "61699563028810";
  var SUNNIE_PRODUCT_ID = "10216988148042";
  var HALLIE_PRODUCT_ID = "10348257935690";
  var REMIE_PRODUCT_ID = "10319777497418";
  /* Excluded from default pack seed; still selectable in the modal. */
  var MYSTERY_GIFT_PRODUCT_ID = "16128308871498";
  /* Fixed pack mix order (after locked PDP slot). Skip ids already used. */
  var MEDIA_BUYBOX_SEED_PRIORITY = [
    DUAL_VARIANT_PRODUCT_ID,
    SUNNIE_PRODUCT_ID,
    HALLIE_PRODUCT_ID,
    REMIE_PRODUCT_ID,
  ];

  /* Released clarity + v2 both require product metafield
     custom.show_bundle_clarity (data-bundle-clarity="true").
     v2 additionally requires html.ab-bundle-clarity-v2. */
  function isBundleClarityRoot(root) {
    return !!(root && root.getAttribute("data-bundle-clarity") === "true");
  }

  function isBundleClarityActive() {
    return !!document.querySelector('quantity-breaks[data-bundle-clarity="true"]');
  }

  function isBundleClarityV2Active() {
    return (
      isBundleClarityActive() &&
      document.documentElement.classList.contains("ab-bundle-clarity-v2")
    );
  }

  var mediaBuyboxV2Preselected = false;

  function isMediaBuyboxV2Active() {
    return document.documentElement.classList.contains("ab-media-buybox-v2");
  }

  function isMediaBuyboxActive() {
    var html = document.documentElement;
    return (
      html.classList.contains("ab-media-buybox") ||
      html.classList.contains("ab-media-buybox-v2")
    );
  }

  /* ab-media-buybox-v2 only: default to Friends pack (2 Hug Buddies / input_2).
     Runs once when the experiment class appears so manual tier changes stick. */
  function preselectFriendsPackForMediaBuyboxV2() {
    if (!isMediaBuyboxV2Active() || mediaBuyboxV2Preselected) return;
    if (!isBundleClarityActive()) return;

    var roots = document.querySelectorAll(
      'quantity-breaks[data-bundle-clarity="true"]',
    );
    if (!roots.length) return;

    var applied = false;

    roots.forEach(function (root) {
      var friends = root.querySelector(
        'input[name="quantity"][data-input="input_2"]',
      );
      if (!friends) return;

      applied = true;
      if (friends.checked) return;

      friends.checked = true;
      friends.dispatchEvent(new Event("change", { bubbles: true }));
    });

    if (applied) mediaBuyboxV2Preselected = true;
  }

  function pickDefaultVariant(animal, sectionId) {
    if (!animal) return null;
    var variant = resolveVariant(animal, getSelectedOptions(sectionId));
    if (variant) return variant;
    if (animal.variants && animal.variants.length) return animal.variants[0];
    return null;
  }

  /* Default pack mix always uses Original Panda — never Heavyweight.
     Heavyweight remains available via the modal Change picker. */
  function pickOriginalPandaVariant(panda) {
    if (!panda || !panda.variants || !panda.variants.length) return null;

    var original = panda.variants.find(function (variant) {
      return String(variant.id) !== DUAL_VARIANT_HEAVY_ID;
    });

    return original || panda.variants[0] || null;
  }

  function pickSeedVariant(animal, sectionId) {
    if (!animal) return null;
    if (isDualVariantProduct(animal.id)) return pickOriginalPandaVariant(animal);
    return pickDefaultVariant(animal, sectionId);
  }

  /* ab-media-buybox(+v2): seed unlocked slots once.
     Slot 0 stays the PDP product. Remaining slots follow
     MEDIA_BUYBOX_SEED_PRIORITY (Panda → Sunnie → Hallie → Remie),
     skipping any id already used. Never overrides user picks. */
  function seedMediaBuyboxDefaultMix(root, catalog, sectionId) {
    if (!isMediaBuyboxActive() || !root || mediaBuyboxMixSeeded.has(root)) {
      return;
    }
    if (!catalog || !catalog.length) return;

    var currentProductId = String(root.dataset.currentProductId || "");
    var didSeed = false;

    root.querySelectorAll(".quantity-break__animal-picker").forEach(function (picker) {
      var slots = picker.querySelectorAll(".animal-picker__slot");
      if (slots.length < 2) return;

      var usedIds = {};
      if (currentProductId) usedIds[currentProductId] = true;
      /* Never auto-seed mystery gift (manual modal pick still allowed). */
      usedIds[String(MYSTERY_GIFT_PRODUCT_ID)] = true;

      var planned = [];
      var need = slots.length - 1;

      for (var p = 0; p < MEDIA_BUYBOX_SEED_PRIORITY.length && planned.length < need; p++) {
        var seedId = String(MEDIA_BUYBOX_SEED_PRIORITY[p]);
        if (usedIds[seedId]) continue;

        var animal = findAnimal(catalog, seedId);
        var variant = pickSeedVariant(animal, sectionId);
        if (!animal || !variant) continue;

        planned.push({ animal: animal, variant: variant });
        usedIds[seedId] = true;
      }

      for (var i = 1; i < slots.length; i++) {
        var slot = slots[i];
        var plan = planned[i - 1];
        if (!plan || !slot) continue;
        if (slot.getAttribute("data-user-picked") === "true") continue;
        updateSlotDisplay(slot, plan.animal, plan.variant);
        didSeed = true;
      }
    });

    mediaBuyboxMixSeeded.add(root);

    if (didSeed) {
      updateFormVariants(root);
      updateTierPrices(root, catalog);
      syncMediaThumbsFromSlots(root, catalog);
    }
  }

  /* Mirror animal-picker selections into the left pack media collage. */
  function syncMediaThumbsFromSlots(root, catalog) {
    if (!isMediaBuyboxActive() || !root) return;

    catalog = catalog || parseCatalog(root);

    root.querySelectorAll(".quantity-break").forEach(function (tier) {
      var media = tier.querySelector(".quantity-break__media");
      var picker = tier.querySelector(".quantity-break__animal-picker");
      if (!media || !picker) return;

      var images = media.querySelectorAll(".quantity-break__media-image");
      var slots = picker.querySelectorAll(".animal-picker__slot");
      if (!images.length || !slots.length) return;

      for (var i = 0; i < images.length; i++) {
        var slot = slots[i];
        var mediaImg = images[i];
        if (!slot || !mediaImg) break;

        var imageUrl = "";
        var altText = "";
        var animal = findAnimal(catalog, slot.dataset.productId);

        if (animal) {
          imageUrl = animal.slot_image || animal.featured_image || "";
          altText = getSlotDisplayName(
            animal,
            findVariantById(animal, slot.dataset.variantId),
          );
        }

        if (!imageUrl) {
          var slotImg = slot.querySelector("img.animal-picker__slot-image");
          if (slotImg) {
            imageUrl =
              slotImg.getAttribute("src") ||
              slotImg.currentSrc ||
              slotImg.src ||
              "";
            altText = slotImg.alt || altText;
          }
        }

        if (!imageUrl) continue;

        /* Drop Liquid srcset or the PDP image keeps winning over src. */
        mediaImg.removeAttribute("srcset");
        mediaImg.removeAttribute("sizes");
        mediaImg.src = imageUrl;
        mediaImg.alt = altText || "";
      }
    });
  }

  function usesDualWeightLabels() {
    return isBundleClarityV2Active() || isMediaBuyboxActive();
  }

  function findActiveQuantityBreaks() {
    if (!isBundleClarityActive()) return null;

    var pickerNode = document.querySelector(
      'quantity-breaks[data-bundle-clarity="true"][data-animal-picker="true"]',
    );
    if (pickerNode) return pickerNode;

    var nodes = document.querySelectorAll(
      'quantity-breaks[data-bundle-clarity="true"]',
    );

    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].querySelector(".animal-picker__slot")) {
        return nodes[i];
      }
    }

    return nodes.length ? nodes[0] : null;
  }

  function getSlotVariantId(slot) {
    return slot.getAttribute("data-variant-id") || slot.dataset.variantId || "";
  }

  function aggregateVariantIds(variantIds) {
    var result = [];

    variantIds.forEach(function (variantId) {
      if (!variantId) return;

      var id = String(variantId);
      var existing = result.find(function (entry) {
        return String(entry.id) === id;
      });

      if (existing) {
        existing.quantity += 1;
      } else {
        result.push({ id: id, quantity: 1 });
      }
    });

    return result;
  }

  function getCheckedQuantityRadio(root) {
    if (!root) return null;

    var checked = root.querySelector('input[name="quantity"]:checked');
    if (checked) return checked;

    var sectionId = root.dataset.section;
    if (!sectionId) return null;

    var formId = "product-form-" + sectionId;
    return document.querySelector(
      'input[name="quantity"][form="' + formId + '"]:checked',
    );
  }

  function getTierForCheckedRadio(root, checked) {
    if (!checked) return null;

    var tier = checked.nextElementSibling;
    if (tier && tier.classList && tier.classList.contains("quantity-break")) {
      return tier;
    }

    var tierInput = checked.getAttribute("data-input") || checked.dataset.input;
    if (!tierInput) return null;

    return root.querySelector(
      '.quantity-break[data-input="' + tierInput + '"]',
    );
  }

  function getItemsFromDom(root) {
    if (!isBundleClarityActive()) return null;

    root = root || findActiveQuantityBreaks();
    if (!root) return null;

    if (root.getAttribute("data-animal-picker") !== "true") {
      var pickerRoot = document.querySelector(
        'quantity-breaks[data-animal-picker="true"]',
      );
      if (pickerRoot) root = pickerRoot;
    }

    var checked = getCheckedQuantityRadio(root);
    if (!checked) return null;

    var qty = parseInt(checked.value, 10);
    if (!qty || qty <= 1) return null;

    var tier = getTierForCheckedRadio(root, checked);
    if (!tier) return null;

    var slots = tier.querySelectorAll(
      ".quantity-break__animal-picker .animal-picker__slot",
    );
    if (!slots.length) return null;

    var variantIds = Array.prototype.map
      .call(slots, getSlotVariantId)
      .filter(Boolean);
    if (!variantIds.length) return null;

    return aggregateVariantIds(variantIds);
  }

  var animalPickerAddPromise = null;

  function setSubmitState(productForm, loading) {
    var button = productForm && productForm.querySelector('[type="submit"]');
    if (!button) return;

    button.classList.toggle("loading", loading);
    button.toggleAttribute("aria-disabled", loading);

    var spinner = button.querySelector(".loading-overlay__spinner");
    if (spinner) spinner.classList.toggle("hidden", !loading);
  }

  function notifyUpCart() {
    if (typeof window.upcartRegisterAddToCart === "function") {
      window.upcartRegisterAddToCart();
      return;
    }

    if (typeof window.upcartRefreshCart === "function") {
      window.upcartRefreshCart();
    }

    window.setTimeout(function () {
      if (typeof window.upcartOpenCart === "function") {
        window.upcartOpenCart();
      }
    }, 150);
  }

  function addAnimalPickerItems(productForm, items) {
    if (animalPickerAddPromise) return animalPickerAddPromise;

    setSubmitState(productForm, true);

    var cartAddUrl =
      window.routes && window.routes.cart_add_url
        ? window.routes.cart_add_url.replace(
            /\/cart\/add(\.js)?$/,
            "/cart/add.js",
          )
        : "/cart/add.js";

    animalPickerAddPromise = fetch(cartAddUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        items: items.map(function (item) {
          return {
            id: parseInt(item.id, 10),
            quantity: parseInt(item.quantity, 10),
          };
        }),
      }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) {
            throw new Error(
              data.description || "Unable to add selected animals to cart.",
            );
          }

          return data;
        });
      })
      .then(function (data) {
        notifyUpCart();
        return data;
      })
      .catch(function (error) {
        console.error("[animal-picker] Cart add failed", error);

        if (
          productForm &&
          typeof productForm.handleErrorMessage === "function"
        ) {
          productForm.handleErrorMessage(error.message);
        }
      })
      .finally(function () {
        animalPickerAddPromise = null;
        setSubmitState(productForm, false);
      });

    return animalPickerAddPromise;
  }

  function handleAnimalPickerCartEvent(event) {
    if (!isBundleClarityActive()) return;

    var productForm;

    if (event.type === "submit") {
      productForm = event.target.closest("product-form");
    } else {
      var button = event.target.closest(
        'product-form .product-form__submit[type="submit"]',
      );
      productForm = button && button.closest("product-form");
    }

    if (!productForm || !productForm.dataset.section) return;

    var root = document.getElementById(
      "quantity-breaks-" + productForm.dataset.section,
    );
    var items = getItemsFromDom(root);
    if (!items || !items.length) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addAnimalPickerItems(productForm, items);
  }

  document.addEventListener("click", handleAnimalPickerCartEvent, true);
  document.addEventListener("submit", handleAnimalPickerCartEvent, true);

  function parseCatalog(root) {
    var script = root.querySelector("[data-animal-catalog]");
    if (!script) return [];

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error("[animal-picker] Invalid catalog JSON", error);
      return [];
    }
  }

  function getSelectedOptions(sectionId) {
    var container =
      document.querySelector(
        'variant-radios[data-section="' + sectionId + '"]',
      ) ||
      document.querySelector(
        'variant-selects[data-section="' + sectionId + '"]',
      );
    if (!container) return [];

    var checked = container.querySelectorAll('input[type="radio"]:checked');
    if (checked.length) {
      return Array.from(checked).map(function (input) {
        return input.value;
      });
    }

    var selects = container.querySelectorAll("select");
    if (selects.length) {
      return Array.from(selects).map(function (select) {
        return select.value;
      });
    }

    return [];
  }

  function getCurrentPdpVariantId(sectionId, catalog, currentProductId) {
    var radios =
      document.querySelector(
        'variant-radios[data-section="' + sectionId + '"]',
      ) ||
      document.querySelector(
        'variant-selects[data-section="' + sectionId + '"]',
      );

    /* Prefer the picker’s resolved variant — hidden input can lag one tick. */
    if (radios && radios.currentVariant && radios.currentVariant.id) {
      return String(radios.currentVariant.id);
    }

    var input = document.querySelector(
      'product-form[data-section="' + sectionId + '"] input[name="id"]',
    );
    if (input && input.value) return String(input.value);

    if (catalog && currentProductId) {
      var animal = findAnimal(catalog, currentProductId);
      var resolved = resolveVariant(animal, getSelectedOptions(sectionId));
      if (resolved) return String(resolved.id);
    }

    return "";
  }

  function syncCurrentVariantMeta(root, catalog, sectionId) {
    if (!root) return null;

    var productId = root.dataset.currentProductId;
    var variantId = getCurrentPdpVariantId(sectionId, catalog, productId);
    var animal = findAnimal(catalog, productId);
    var variant = findVariantById(animal, variantId);

    if (!variant && animal) {
      variant = resolveVariant(animal, getSelectedOptions(sectionId));
    }
    if (!variant) return null;

    var priceCents = getVariantPriceCents(variant, 0);
    var compareCents = getVariantCompareCents(variant, priceCents);
    root.dataset.currentVariantPrice = String(priceCents);
    root.dataset.currentVariantCompare = String(compareCents);
    root.setAttribute("data-current-variant-price", String(priceCents));
    root.setAttribute("data-current-variant-compare", String(compareCents));
    return variant;
  }

  function resolveVariant(animal, selectedOptions) {
    if (!animal || !animal.variants || !animal.variants.length) return null;

    if (selectedOptions.length) {
      var matched = animal.variants.find(function (variant) {
        if (!variant.available) return false;

        return selectedOptions.every(function (opt, index) {
          var key = "option" + (index + 1);
          return !variant[key] || variant[key] === opt;
        });
      });

      if (matched) return matched;
    }

    return (
      animal.variants.find(function (variant) {
        return variant.available;
      }) || animal.variants[0]
    );
  }

  function findAnimal(catalog, productId) {
    var id = String(productId);

    return catalog.find(function (animal) {
      return String(animal.id) === id;
    });
  }

  function findVariantById(animal, variantId) {
    if (!animal || !animal.variants || !variantId) return null;

    return (
      animal.variants.find(function (variant) {
        return String(variant.id) === String(variantId);
      }) || null
    );
  }

  function isDualVariantProduct(productId) {
    return String(productId) === DUAL_VARIANT_PRODUCT_ID;
  }

  function getAnimalDisplayName(title) {
    return String(title || "")
      .replace(/\s+Weighted Animal/i, "")
      .replace(/\s+Weighted Hug Buddy/i, "")
      .replace(/\s+Weighted Cuddle Buddy/i, "")
      .trim();
  }

  function positionAnimalModal(root, modal) {
    var dialog = modal && modal.querySelector(".animal-picker-modal__dialog");
    if (!dialog || !root) return;

    /* Mobile bottom sheet is CSS-owned.
       ab-media-buybox uses 849px; control stays at Dawn's 749px. */
    var mobileQuery = isMediaBuyboxActive()
      ? "(max-width: 849px)"
      : "(max-width: 749px)";
    if (window.matchMedia(mobileQuery).matches) {
      dialog.style.removeProperty("top");
      dialog.style.removeProperty("left");
      dialog.style.removeProperty("right");
      dialog.style.removeProperty("width");
      dialog.style.removeProperty("max-width");
      dialog.style.removeProperty("max-height");
      dialog.style.removeProperty("transform");
      return;
    }

    var rect = root.getBoundingClientRect();
    var gutter = 16;
    var preferredWidth = Math.min(460, Math.max(rect.width, 320));

    dialog.style.right = "auto";
    dialog.style.width = preferredWidth + "px";
    dialog.style.maxWidth = "calc(100vw - " + gutter * 2 + "px)";
    dialog.style.maxHeight = "calc(100vh - " + gutter * 2 + "px)";
    dialog.style.transform = "none";

    var dw = dialog.offsetWidth;
    var dh = dialog.offsetHeight;
    var left = rect.left + (rect.width - dw) / 2;
    var top = rect.top + (rect.height - dh) / 2;

    left = Math.min(Math.max(gutter, left), window.innerWidth - dw - gutter);
    top = Math.min(Math.max(gutter, top), window.innerHeight - dh - gutter);

    dialog.style.left = left + "px";
    dialog.style.top = top + "px";
  }

  function getSlotDisplayName(animal, variant) {
    var name = getAnimalDisplayName(animal && animal.title);

    if (!usesDualWeightLabels() || !animal || !isDualVariantProduct(animal.id)) {
      return name;
    }

    if (variant && String(variant.id) === DUAL_VARIANT_HEAVY_ID) {
      return name + " Heavyweight";
    }

    return name + " Original";
  }

  function getModalPackLabel(slotCount) {
    if (Number(slotCount) === 4) return "Family pack";
    return "Friends pack";
  }

  function getModalOptionEntries(catalog, sectionId) {
    var entries = [];
    var selectedOptions = getSelectedOptions(sectionId);

    (catalog || []).forEach(function (animal) {
      if (!animal) return;

      if (isDualVariantProduct(animal.id) && animal.variants && animal.variants.length) {
        var original = null;
        var heavy = null;

        animal.variants.forEach(function (variant) {
          if (String(variant.id) === DUAL_VARIANT_HEAVY_ID) {
            heavy = variant;
          } else if (!original) {
            original = variant;
          }
        });

        if (original) {
          entries.push({
            animal: animal,
            variant: original,
            label: getSlotDisplayName(animal, original),
            imageUrl: animal.picker_image || animal.featured_image || "",
          });
        }
        if (heavy) {
          entries.push({
            animal: animal,
            variant: heavy,
            label: getSlotDisplayName(animal, heavy),
            imageUrl: animal.picker_image || animal.featured_image || "",
          });
        }
        return;
      }

      var variant = resolveVariant(animal, selectedOptions);
      if (!variant && animal.variants && animal.variants.length) {
        variant = animal.variants[0];
      }
      if (!variant) return;

      entries.push({
        animal: animal,
        variant: variant,
        label: getSlotDisplayName(animal, variant),
        imageUrl: animal.picker_image || animal.featured_image || "",
      });
    });

    return entries;
  }

  function getAnimalModal(root) {
    if (root && root.__animalModal) return root.__animalModal;
    var modal = root && root.querySelector("[data-animal-picker-modal]");
    if (modal && root) root.__animalModal = modal;
    return modal;
  }

  function lockAnimalModalScroll() {
    if (document.documentElement.classList.contains("animal-picker-modal-open")) {
      return;
    }

    var scrollY = window.scrollY || window.pageYOffset || 0;
    var scrollbar = window.innerWidth - document.documentElement.clientWidth;

    document.documentElement.classList.add("animal-picker-modal-open");
    document.documentElement.dataset.animalModalScrollY = String(scrollY);
    document.body.style.position = "fixed";
    document.body.style.top = "-" + scrollY + "px";
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
    if (scrollbar > 0) {
      document.body.style.paddingRight = scrollbar + "px";
    }
  }

  function unlockAnimalModalScroll() {
    if (!document.documentElement.classList.contains("animal-picker-modal-open")) {
      return;
    }

    var scrollY =
      parseInt(document.documentElement.dataset.animalModalScrollY || "0", 10) ||
      0;

    document.documentElement.classList.remove("animal-picker-modal-open");
    delete document.documentElement.dataset.animalModalScrollY;
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    document.body.style.paddingRight = "";
    window.scrollTo(0, scrollY);
  }

  function closeAnimalModal(root) {
    var modal = getAnimalModal(root);
    if (!modal) return;

    modal.hidden = true;
    modal.classList.remove("is-open");
    unlockAnimalModalScroll();
    modal.__activeSlot = null;
    modal.__pending = null;

    if (modal.__homeParent && modal.parentNode !== modal.__homeParent) {
      modal.__homeParent.appendChild(modal);
    }

    if (root) {
      root
        .querySelectorAll(
          '.animal-picker__slot-action--change[aria-expanded="true"]',
        )
        .forEach(function (btn) {
          btn.setAttribute("aria-expanded", "false");
        });
    }
  }

  function updateModalConfirm(modal) {
    var confirmBtn = modal.querySelector("[data-animal-modal-confirm]");
    var pending = modal.__pending;
    if (!confirmBtn) return;

    if (!pending || !pending.label) {
      confirmBtn.textContent = "Confirm";
      confirmBtn.disabled = true;
      return;
    }

    confirmBtn.disabled = false;
    confirmBtn.textContent = "Confirm " + pending.label;
  }

  function setModalSelection(modal, productId, variantId, label) {
    modal.__pending = {
      productId: String(productId || ""),
      variantId: String(variantId || ""),
      label: label || "",
    };

    modal.querySelectorAll("[data-animal-modal-option]").forEach(function (card) {
      var selected =
        String(card.dataset.productId) === String(productId) &&
        String(card.dataset.variantId || "") === String(variantId || "");
      card.classList.toggle("is-selected", selected);
      card.setAttribute("aria-selected", selected ? "true" : "false");
    });

    updateModalConfirm(modal);
  }

  function renderAnimalModalGrid(modal, catalog, sectionId, selectedProductId, selectedVariantId) {
    var grid = modal.querySelector("[data-animal-modal-grid]");
    if (!grid) return;

    var checkSrc = modal.getAttribute("data-check-src") || "";
    var entries = getModalOptionEntries(catalog, sectionId);
    var html = "";

    entries.forEach(function (entry) {
      var selected =
        String(entry.animal.id) === String(selectedProductId) &&
        String(entry.variant.id) === String(selectedVariantId);
      var image = entry.imageUrl
        ? '<img class="animal-picker-modal__option-image" src="' +
          entry.imageUrl +
          '" alt="" width="216" height="216" loading="lazy" decoding="async">'
        : '<span class="animal-picker-modal__option-image animal-picker-modal__option-image--placeholder"></span>';
      var check = checkSrc
        ? '<img class="animal-picker-modal__check" src="' +
          checkSrc +
          '" alt="" width="27" height="27" aria-hidden="true">'
        : '<span class="animal-picker-modal__check" aria-hidden="true"></span>';

      html +=
        '<button type="button" class="animal-picker-modal__option' +
        (selected ? " is-selected" : "") +
        '" role="option" aria-selected="' +
        (selected ? "true" : "false") +
        '" data-animal-modal-option data-product-id="' +
        entry.animal.id +
        '" data-variant-id="' +
        entry.variant.id +
        '" data-label="' +
        String(entry.label).replace(/"/g, "&quot;") +
        '">' +
        '<span class="animal-picker-modal__option-media">' +
        image +
        check +
        "</span>" +
        '<span class="animal-picker-modal__option-name">' +
        entry.label +
        "</span>" +
        "</button>";
    });

    grid.innerHTML = html;
    setModalSelection(
      modal,
      selectedProductId,
      selectedVariantId,
      (
        entries.find(function (entry) {
          return (
            String(entry.animal.id) === String(selectedProductId) &&
            String(entry.variant.id) === String(selectedVariantId)
          );
        }) || {}
      ).label || "",
    );
  }

  function openAnimalModal(root, catalog, slot, changeBtn) {
    var modal = getAnimalModal(root);
    var picker = slot && slot.closest(".animal-picker");
    if (!modal || !picker || !slot) return;

    closeAllOptionPanels(root);

    var slotCount = parseInt(picker.getAttribute("data-slot-count") || "0", 10) || 0;
    var slotIndex = parseInt(slot.dataset.slotIndex || "0", 10) || 0;
    var animalNumber = slotIndex + 1;
    var packLabel = getModalPackLabel(slotCount);

    var titleEl = modal.querySelector("[data-animal-modal-title]");
    var subtitleEl = modal.querySelector("[data-animal-modal-subtitle]");
    var infoTitleEl = modal.querySelector("[data-animal-modal-info-title]");

    if (titleEl) {
      titleEl.textContent =
        "Choose animal " + animalNumber + " of " + slotCount;
    }
    if (subtitleEl) {
      subtitleEl.textContent = "Pick a buddy for your " + packLabel;
    }
    if (infoTitleEl) {
      infoTitleEl.textContent =
        "Mix & match any " + slotCount + " buddies";
    }

    modal.__activeSlot = slot;
    modal.__homeParent = modal.__homeParent || modal.parentNode;
    root.__animalModal = modal;
    renderAnimalModalGrid(
      modal,
      catalog,
      root.dataset.section,
      slot.dataset.productId,
      slot.dataset.variantId,
    );

    /* Mount on body so theme stacking/overflow cannot clip or hide the overlay. */
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    modal.hidden = false;
    modal.classList.add("is-open");
    lockAnimalModalScroll();
    if (changeBtn) changeBtn.setAttribute("aria-expanded", "true");
    positionAnimalModal(root, modal);

    if (!modal.__positionBound) {
      modal.__positionBound = true;
      var reposition = function () {
        if (modal.hidden || !isMediaBuyboxActive()) return;
        positionAnimalModal(root, modal);
      };
      window.addEventListener("resize", reposition);
      window.addEventListener("scroll", reposition, true);
    }

    var confirmBtn = modal.querySelector("[data-animal-modal-confirm]");
    if (confirmBtn) confirmBtn.focus();
  }

  function confirmAnimalModal(root, catalog) {
    var modal = getAnimalModal(root);
    if (!modal || !modal.__activeSlot || !modal.__pending) return;

    var slot = modal.__activeSlot;
    var pending = modal.__pending;
    var animal = findAnimal(catalog, pending.productId);
    var variant = findVariantById(animal, pending.variantId);

    if (!variant && animal) {
      variant = resolveVariant(animal, getSelectedOptions(root.dataset.section));
    }

    if (slot && animal && variant) {
      slot.setAttribute("data-user-picked", "true");
      updateSlotDisplay(slot, animal, variant);
    }

    closeAnimalModal(root);
    syncAnimalPicker(root, catalog, root.dataset.section);
  }

  function getPresentmentCurrency(root) {
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      return String(Shopify.currency.active).toUpperCase();
    }
    if (root && root.dataset && root.dataset.currency) {
      return String(root.dataset.currency).toUpperCase();
    }
    return "USD";
  }

  function getCurrencySymbol(currency) {
    var symbols = {
      USD: "$",
      EUR: "€",
      GBP: "£",
      CAD: "CA$",
      AUD: "A$",
      NZD: "NZ$",
      CHF: "CHF ",
      SEK: "SEK ",
      NOK: "NOK ",
      DKK: "DKK ",
      PLN: "PLN ",
      INR: "₹",
      JPY: "¥",
      SGD: "S$",
      HKD: "HK$",
      MXN: "MX$",
    };
    return symbols[currency] || currency + " ";
  }

  /* Always symbol-before amount (e.g. €95.00), matching theme money style. */
  function formatMoney(cents, root) {
    var value = Math.max(0, Math.round(Number(cents) || 0));
    var currency = getPresentmentCurrency(root);
    var amount = (value / 100).toFixed(currency === "JPY" ? 0 : 2);
    var symbol = getCurrencySymbol(currency);

    if (symbol.charAt(symbol.length - 1) === " ") {
      return symbol + amount;
    }
    return symbol + amount;
  }

  /* Match Shopify automatic % discounts (allocation "each"):
     floor the per-unit discount, then × qty. Math.round(unit×left/100)
     understates cart by 1¢/unit (2–4¢ on Friends/Family). */
  function discountedUnitCents(unitCents, pctOff) {
    var unit = Math.max(0, Math.round(Number(unitCents) || 0));
    var pct = parseFloat(pctOff);
    if (isNaN(pct)) pct = 0;
    var discount = Math.floor((unit * pct) / 100);
    return Math.max(0, unit - discount);
  }

  function applyTierDiscount(subtotalCents, tier, unitCents, quantity) {
    var type = (tier.dataset.discountType || "none").toLowerCase();
    var subtotal = Math.max(0, Math.round(Number(subtotalCents) || 0));

    if (type === "percentage") {
      var pct = parseFloat(tier.dataset.percentageOff || "0");
      if (isNaN(pct)) pct = 0;
      var qty = Math.max(0, Math.round(Number(quantity) || 0));
      var unit = Math.max(0, Math.round(Number(unitCents) || 0));
      if (qty > 0 && unit > 0) {
        return discountedUnitCents(unit, pct) * qty;
      }
      return Math.round((subtotal * (100 - pct)) / 100);
    }

    if (type === "fixed_amount") {
      var fixedDollars = parseFloat(tier.dataset.fixedAmountOff || "0");
      if (isNaN(fixedDollars)) fixedDollars = 0;
      return Math.max(0, subtotal - Math.round(fixedDollars * 100));
    }

    return subtotal;
  }

  function getVariantPriceCents(variant, fallbackCents) {
    if (variant && variant.price != null && !isNaN(Number(variant.price))) {
      return Math.round(Number(variant.price));
    }
    return Math.round(Number(fallbackCents) || 0);
  }

  function getVariantCompareCents(variant, priceCents) {
    if (
      variant &&
      variant.compare_at_price != null &&
      !isNaN(Number(variant.compare_at_price)) &&
      Number(variant.compare_at_price) > 0
    ) {
      return Math.round(Number(variant.compare_at_price));
    }
    return priceCents;
  }

  function updateTierPrices(root, catalog) {
    /* Sum each picker slot's variant price (+ tier discount). Required whenever
       bundle clarity has the animal picker; was incorrectly gated to v2 only. */
    if (!isBundleClarityActive() || !root) return;
    if (!root.querySelector(".animal-picker__slot")) return;

    var sectionId = root.dataset.section;
    syncCurrentVariantMeta(root, catalog, sectionId);

    var fallbackPrice = parseInt(root.dataset.currentVariantPrice || "0", 10) || 0;
    var fallbackCompare =
      parseInt(root.dataset.currentVariantCompare || "0", 10) || fallbackPrice;
    var pdpVariantId = getCurrentPdpVariantId(
      sectionId,
      catalog,
      root.dataset.currentProductId,
    );
    var currentProductId = root.dataset.currentProductId;

    root.querySelectorAll(".quantity-break").forEach(function (tier) {
      var priceEl = tier.querySelector(".quantity-break__price");
      if (!priceEl) return;

      var qty = parseInt(tier.dataset.quantity || "0", 10) || 0;
      var picker = tier.querySelector(".quantity-break__animal-picker");
      var slots = picker
        ? picker.querySelectorAll(".animal-picker__slot")
        : [];

      var subtotal = 0;
      var compareSubtotal = 0;
      var saleCents = 0;
      var pctOff = parseFloat(tier.dataset.percentageOff || "0");
      var discountType = (tier.dataset.discountType || "none").toLowerCase();

      if (slots.length && qty > 1) {
        slots.forEach(function (slot) {
          var animal = findAnimal(catalog, slot.dataset.productId);
          var slotVariantId = slot.dataset.variantId;
          var userPicked = slot.getAttribute("data-user-picked") === "true";
          var isCurrentProduct =
            String(slot.dataset.productId || "") ===
            String(currentProductId || "");

          /* Untouched current-product slots follow PDP weight for pricing. */
          if (
            isCurrentProduct &&
            !userPicked &&
            pdpVariantId &&
            isDualVariantProduct(slot.dataset.productId)
          ) {
            slotVariantId = pdpVariantId;
          }

          var variant = findVariantById(animal, slotVariantId);
          if (!variant && animal) {
            variant = resolveVariant(
              animal,
              getSelectedOptions(sectionId),
            );
          }
          var priceCents = getVariantPriceCents(variant, fallbackPrice);
          var compareCents = getVariantCompareCents(variant, priceCents);
          subtotal += priceCents;
          compareSubtotal += compareCents;
          if (discountType === "percentage") {
            saleCents += discountedUnitCents(priceCents, pctOff);
          }
        });
        if (discountType !== "percentage") {
          saleCents = applyTierDiscount(subtotal, tier);
        }
      } else if (qty > 0) {
        subtotal = fallbackPrice * qty;
        compareSubtotal = fallbackCompare * qty;
        saleCents = applyTierDiscount(subtotal, tier, fallbackPrice, qty);
      } else {
        return;
      }

      priceEl.textContent = formatMoney(saleCents, root);

      var captionEl = tier.querySelector(
        ".quantity-break__ab-caption-text--clarity",
      );
      if (captionEl && qty > 0) {
        /* Mixed slots: average sale per animal (matches pack total ÷ qty). */
        var perAnimalCents = Math.floor(saleCents / qty);
        captionEl.textContent =
          formatMoney(perAnimalCents, root) + " per animal";
      }

      var compareEl = tier.querySelector(".quantity-break__compare-price");
      if (compareEl) {
        compareEl.textContent = formatMoney(compareSubtotal, root);
        if (compareSubtotal <= saleCents) {
          compareEl.style.display = "none";
        } else {
          compareEl.style.removeProperty("display");
        }
      }

      var saveEl = tier.querySelector(".quantity-break__ab-save");
      if (saveEl) {
        var saveCents = Math.max(0, compareSubtotal - saleCents);
        if (saveCents > 0) {
          saveEl.textContent = "Save " + formatMoney(saveCents, root);
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }
    });

    try {
      document.dispatchEvent(
        new CustomEvent("quantity-breaks:prices-updated", { bubbles: true }),
      );
    } catch (e) {}
  }

  function closeAllOptionPanels(root, except) {
    root
      .querySelectorAll(".animal-picker__options")
      .forEach(function (optionsPanel) {
        if (except && optionsPanel === except) return;

        optionsPanel.hidden = true;

        var picker = optionsPanel.closest(".animal-picker");
        if (!picker) return;

        var slot = picker.querySelector(
          '.animal-picker__slot[data-slot-index="' +
            optionsPanel.dataset.slotIndex +
            '"]',
        );
        if (!slot) return;

        var changeButton = slot.querySelector(
          ".animal-picker__slot-action--change",
        );
        if (changeButton) changeButton.setAttribute("aria-expanded", "false");
      });
  }

  function setSlotImage(slot, imageUrl, altText) {
    if (!imageUrl) return;

    var media = slot.querySelector(".animal-picker__slot-media");
    if (!media) {
      media = document.createElement("span");
      media.className = "animal-picker__slot-media";
      var nameEl = slot.querySelector(".animal-picker__slot-name");
      if (nameEl && nameEl.parentNode) {
        nameEl.parentNode.insertBefore(media, nameEl);
      } else {
        slot.prepend(media);
      }
    }

    var existing = media.querySelector(".animal-picker__slot-image");
    var img = document.createElement("img");

    img.className = "animal-picker__slot-image";
    img.src = imageUrl;
    img.alt = altText || "";
    img.loading = "lazy";
    img.width = 160;
    img.height = 160;

    if (existing) {
      existing.replaceWith(img);
    } else {
      media.appendChild(img);
    }
  }

  function updateSlotDisplay(slot, animal, variant) {
    if (!animal || !variant) return;

    slot.setAttribute("data-product-id", String(animal.id));
    slot.setAttribute("data-variant-id", String(variant.id));
    slot.dataset.productId = String(animal.id);
    slot.dataset.variantId = String(variant.id);

    var displayName = getSlotDisplayName(animal, variant);
    var nameEl = slot.querySelector(".animal-picker__slot-name");
    if (nameEl) nameEl.textContent = displayName;

    var imageUrl = animal.slot_image || animal.featured_image;
    var picker = slot.closest(".animal-picker");
    var optionsPanel =
      picker &&
      picker.querySelector(
        '.animal-picker__options[data-slot-index="' +
          slot.dataset.slotIndex +
          '"]',
      );

    if (!imageUrl) {
      var fallbackOption =
        optionsPanel &&
        optionsPanel.querySelector(
          '.animal-picker__option[data-product-id="' +
            animal.id +
            '"][data-variant-id="' +
            variant.id +
            '"]',
        );
      if (!fallbackOption && optionsPanel) {
        fallbackOption = optionsPanel.querySelector(
          '.animal-picker__option[data-product-id="' + animal.id + '"]',
        );
      }
      if (fallbackOption) imageUrl = fallbackOption.dataset.imageUrl;
    }

    setSlotImage(slot, imageUrl, displayName);

    if (optionsPanel) {
      optionsPanel
        .querySelectorAll(".animal-picker__option")
        .forEach(function (option) {
          var selected =
            String(option.dataset.productId) === String(animal.id) &&
            String(option.dataset.variantId || "") === String(variant.id);
          option.classList.toggle("is-selected", selected);
          option.setAttribute("aria-selected", selected ? "true" : "false");
        });
    }
  }

  function syncSlotVariants(root, catalog, sectionId) {
    syncCurrentVariantMeta(root, catalog, sectionId);

    var selectedOptions = getSelectedOptions(sectionId);
    var currentProductId = root.dataset.currentProductId;
    var pdpVariantId = getCurrentPdpVariantId(
      sectionId,
      catalog,
      currentProductId,
    );
    /* Sync every pack's slots (Friends + Family), not only the checked tier. */
    var slots = root.querySelectorAll(
      ".quantity-break__animal-picker .animal-picker__slot",
    );

    slots.forEach(function (slot) {
      var productId = slot.dataset.productId || currentProductId;
      var animal = findAnimal(catalog, productId);
      if (!animal) return;

      var isLocked = slot.classList.contains("animal-picker__slot--locked");
      var userPicked = slot.getAttribute("data-user-picked") === "true";
      var isCurrentProduct =
        String(productId) === String(currentProductId || "");
      var variant = null;

      if (usesDualWeightLabels() && isDualVariantProduct(animal.id)) {
        /* Locked slot + untouched current-product slots follow PDP weight
           (so Family pack preselects Heavyweight too). */
        if (isLocked || (isCurrentProduct && !userPicked)) {
          if (pdpVariantId) {
            variant = findVariantById(animal, pdpVariantId);
          }
          if (!variant) {
            variant = resolveVariant(animal, selectedOptions);
          }
        } else if (slot.dataset.variantId) {
          variant = findVariantById(animal, slot.dataset.variantId);
        }
      }

      if (!variant) {
        variant = resolveVariant(animal, selectedOptions);
      }

      if (variant) updateSlotDisplay(slot, animal, variant);
    });
  }

  function updateFormVariants(root) {
    if (!root.formVariants) root.formVariants = [];

    var items = getItemsFromDom(root);
    root.formVariants = items || [];
  }

  function syncAnimalPicker(root, catalog, sectionId) {
    if (!isBundleClarityActive()) return [];

    if (catalog && sectionId) {
      syncSlotVariants(root, catalog, sectionId);
    }

    updateFormVariants(root);
    updateTierPrices(root, catalog || parseCatalog(root));
    syncMediaThumbsFromSlots(root, catalog);
    return getItemsFromDom(root) || root.formVariants || [];
  }

  function bindDocumentClick() {
    if (window.__animalPickerDocumentClickBound) return;
    window.__animalPickerDocumentClickBound = true;

    document.addEventListener("click", function (event) {
      if (!isBundleClarityActive()) return;

      document.querySelectorAll("quantity-breaks").forEach(function (root) {
        if (!root.querySelector(".animal-picker__slot")) return;
        if (!root.contains(event.target)) closeAllOptionPanels(root);
      });
    });
  }

  function bindEvents(root, catalog) {
    var sectionId = root.dataset.section;

    root.syncAnimalPickerFormVariants = function () {
      if (!isBundleClarityActive()) return [];
      return syncAnimalPicker(root, catalog, sectionId);
    };

    root.addEventListener("change", function (event) {
      if (!isBundleClarityActive()) return;

      if (event.target.matches('input[name="quantity"]')) {
        closeAllOptionPanels(root);
        closeAnimalModal(root);
        syncSlotVariants(root, catalog, sectionId);
        updateFormVariants(root);
        updateTierPrices(root, catalog);
        syncMediaThumbsFromSlots(root, catalog);
      }
    });

    root.addEventListener(
      "click",
      function (event) {
        if (!isBundleClarityActive()) return;

        var changeBtn = event.target.closest(
          ".animal-picker__slot-action--change",
        );

        if (changeBtn) {
          event.preventDefault();
          event.stopPropagation();

          var slot = changeBtn.closest(".animal-picker__slot");
          var picker = slot && slot.closest(".animal-picker");
          if (!slot || !picker) return;

          if (isMediaBuyboxActive()) {
            openAnimalModal(root, catalog, slot, changeBtn);
            return;
          }

          var optionsPanel = picker.querySelector(
            '.animal-picker__options[data-slot-index="' +
              slot.dataset.slotIndex +
              '"]',
          );
          if (!optionsPanel) return;

          var willOpen = optionsPanel.hidden;
          closeAllOptionPanels(root, willOpen ? optionsPanel : null);
          optionsPanel.hidden = !willOpen;
          changeBtn.setAttribute("aria-expanded", willOpen ? "true" : "false");
          return;
        }

        var optionBtn = event.target.closest(".animal-picker__option");

        if (optionBtn && !optionBtn.disabled) {
          event.preventDefault();
          event.stopPropagation();

          var optionsPanel = optionBtn.closest(".animal-picker__options");
          var picker = optionsPanel && optionsPanel.closest(".animal-picker");
          var slot =
            picker &&
            picker.querySelector(
              '.animal-picker__slot[data-slot-index="' +
                optionsPanel.dataset.slotIndex +
                '"]',
            );
          var animal = findAnimal(catalog, optionBtn.dataset.productId);
          var variant = null;

          if (
            usesDualWeightLabels() &&
            animal &&
            isDualVariantProduct(animal.id) &&
            optionBtn.dataset.variantId
          ) {
            variant = findVariantById(animal, optionBtn.dataset.variantId);
          }

          if (!variant && animal) {
            variant = resolveVariant(animal, getSelectedOptions(sectionId));
          }

          if (slot && animal && variant) {
            if (!animal.slot_image && optionBtn.dataset.imageUrl) {
              animal = Object.assign({}, animal, {
                slot_image: optionBtn.dataset.imageUrl,
              });
            }

            slot.setAttribute("data-user-picked", "true");
            updateSlotDisplay(slot, animal, variant);
          }

          closeAllOptionPanels(root);
          syncAnimalPicker(root, catalog, sectionId);
        }
      },
      true,
    );

    var modal = getAnimalModal(root);
    if (modal && !modal.__animalModalBound) {
      modal.__animalModalBound = true;
      root.__animalModal = modal;
      modal.__homeParent = modal.parentNode;
      modal.__ownerRoot = root;

      modal.addEventListener("click", function (event) {
        if (!isBundleClarityActive() || !isMediaBuyboxActive()) return;

        var ownerRoot = modal.__ownerRoot || root;

        if (
          event.target === modal ||
          event.target.closest("[data-animal-modal-close]")
        ) {
          event.preventDefault();
          closeAnimalModal(ownerRoot);
          return;
        }

        var optionCard = event.target.closest("[data-animal-modal-option]");
        if (optionCard) {
          event.preventDefault();
          setModalSelection(
            modal,
            optionCard.dataset.productId,
            optionCard.dataset.variantId,
            optionCard.dataset.label || optionCard.textContent.trim(),
          );
          return;
        }

        if (event.target.closest("[data-animal-modal-confirm]")) {
          event.preventDefault();
          confirmAnimalModal(ownerRoot, catalog);
        }
      });
    }

    if (!window.__animalPickerModalEscapeBound) {
      window.__animalPickerModalEscapeBound = true;
      document.addEventListener("keydown", function (event) {
        if (event.key !== "Escape") return;
        if (!isMediaBuyboxActive()) return;

        document
          .querySelectorAll("[data-animal-picker-modal].is-open")
          .forEach(function (openModal) {
            var ownerRoot =
              openModal.__ownerRoot ||
              openModal.closest("quantity-breaks");
            if (ownerRoot) closeAnimalModal(ownerRoot);
          });
      });
    }

    var variantRadios = document.querySelector(
      'variant-radios[data-section="' + sectionId + '"]',
    );
    var variantSelects = document.querySelector(
      'variant-selects[data-section="' + sectionId + '"]',
    );
    var variantPicker = variantRadios || variantSelects;

    function onPdpVariantChange() {
      if (!isBundleClarityActive()) return;
      syncAnimalPicker(root, catalog, sectionId);
    }

    if (variantPicker) {
      variantPicker.addEventListener("change", onPdpVariantChange);
    }

    var variantInput = document.querySelector(
      'product-form[data-section="' + sectionId + '"] input[name="id"]',
    );

    if (variantInput) {
      variantInput.addEventListener("change", onPdpVariantChange);
    }

    /* After theme replaces option-N-price HTML from section fetch, re-apply
       slot-based Heavyweight pricing so Friends/Family don't snap back. */
    if (
      !root.__animalPickerVariantChangeBound &&
      typeof subscribe === "function" &&
      typeof PUB_SUB_EVENTS !== "undefined" &&
      PUB_SUB_EVENTS.variantChange
    ) {
      root.__animalPickerVariantChangeBound = true;
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!isBundleClarityActive()) return;
        var eventSection =
          event && event.data && (event.data.sectionId || event.data.section);
        if (eventSection && String(eventSection) !== String(sectionId)) return;
        syncAnimalPicker(root, catalog, sectionId);
      });
    }
  }

  function initAnimalPicker(root) {
    if (!root || !isBundleClarityRoot(root)) return;
    if (!root.querySelector(".animal-picker__slot")) return;

    root
      .querySelectorAll(".quantity-break__animal-picker")
      .forEach(function (picker) {
        picker.hidden = false;
      });

    var catalog = parseCatalog(root);

    if (initialized.has(root)) {
      if (typeof root.syncAnimalPickerFormVariants === "function") {
        root.syncAnimalPickerFormVariants();
      }
      seedMediaBuyboxDefaultMix(root, catalog, root.dataset.section);
      return;
    }

    if (!catalog.length) return;

    initialized.add(root);
    if (!root.formVariants) root.formVariants = [];

    bindDocumentClick();
    bindEvents(root, catalog);
    syncAnimalPicker(root, catalog, root.dataset.section);
    seedMediaBuyboxDefaultMix(root, catalog, root.dataset.section);
  }

  function initAll() {
    if (!isBundleClarityActive()) return;

    document
      .querySelectorAll('quantity-breaks[data-bundle-clarity="true"]')
      .forEach(function (root) {
        initAnimalPicker(root);
      });
  }

  function deactivateAll() {
    document
      .querySelectorAll('quantity-breaks[data-bundle-clarity="true"]')
      .forEach(function (root) {
        root.formVariants = [];
        closeAllOptionPanels(root);
        closeAnimalModal(root);

        root
          .querySelectorAll(".quantity-break__animal-picker")
          .forEach(function (picker) {
            picker.hidden = true;
          });
      });
  }

  function syncExperimentState() {
    if (!isBundleClarityActive()) {
      deactivateAll();
      document
        .querySelectorAll("[data-bundle-clarity-content]")
        .forEach(function (element) {
          element.hidden = true;
        });
      return;
    }

    document
      .querySelectorAll(
        'quantity-breaks[data-bundle-clarity="true"] [data-bundle-clarity-content]',
      )
      .forEach(function (element) {
        /* save_badge is v2-only; CSS also hides it without the v2 class. */
        var isV2Only = element.classList.contains(
          "quantity-break__ab-save-badge",
        );
        element.hidden = isV2Only ? !isBundleClarityV2Active() : false;
      });

    initAll();
    preselectFriendsPackForMediaBuyboxV2();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncExperimentState);
  } else {
    syncExperimentState();
  }

  document.addEventListener("shopify:section:load", function () {
    mediaBuyboxV2Preselected = false;
    syncExperimentState();
  });

  new MutationObserver(function () {
    if (!isMediaBuyboxV2Active()) mediaBuyboxV2Preselected = false;
    syncExperimentState();
  }).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["class"],
  });

  window.AnimalPicker = {
    getItems: getItemsFromDom,
    findRoot: findActiveQuantityBreaks,
  };
})();
